import React from "react";
import { ChatOverlay, Sidebar, Topbar } from "@components";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const LayoutWithSidebar = () => {
    return (
        <div className="app">
            <Sidebar />
            <main className="content">
                <Box className='sticky top-0 z-10'>
                    <Topbar />
                </Box>
                <Box className='mt-5  w-[95%] mx-auto overflow-y-auto'>
                    <Outlet />
                </Box>
                <ChatOverlay />
            </main>
        </div>
    );
};

export default LayoutWithSidebar;